<template>
  <footer
    class="industify_fn_footer"
    data-subscribe="enable"
    data-triple="enable"
    data-b-widget="enable"
    data-copy="enable"
  >
    <div class="top_footer">
      <div class="top_footer_img"></div>
      <div class="footer_widget">
        <div class="container">
          <div class="inner">
            <ul class="widget_area">
              <li>
                <div class="item">
                  <div class="widget_block clearfix widget_text">
                    <div class="row">
                      <router-link to="/">
                        <img
                          class="footer-logo"
                          src="../assets/images/logo.svg"
                        />
                      </router-link>
                      <div class="textwidget" v-html="getDesc">
                        
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li>
                <div class="item">
                  <div class="widget_block clearfix widget_nav_menu">
                    <div>
                      <div class="wid-title">
                        <span>{{$t("navigation")}}</span>
                      </div>
                      <div class="menu-helpful-menu-container">
                        <ul class="menu">
                          <li>
                            <router-link :to="`/${locale}/about`">{{ $t("nav.about_us") }}</router-link>
                          </li>
                          <li>
                            <router-link :to="`/${locale}/projects`"
                              >{{ $t("nav.projects") }}</router-link
                            >
                          </li>
                          <li>
                            <router-link :to="`/${locale}/references`"
                              >{{ $t("nav.references") }}</router-link
                            >
                          </li>
                          <li>
                            <router-link :to="`/${locale}/licenses-and-certificates`"
                              >{{ $t("nav.licenses_and_certificates") }}</router-link
                            >
                          </li>
                          <li>
                            <router-link :to="`/${locale}/news`">{{ $t("nav.news") }}</router-link>
                          </li>
                          <!-- <li>
                            <router-link :to="`/${locale}/contacts`">{{ $t("nav.contact") }}</router-link>
                          </li> -->
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="footer_bottom">
      <div class="container">
        <div class="footer_bottom_in">
          <div class="footer_copyright">
            <p>2020 © All rights reserved.</p>
          </div>
          <a class="scrolled" v-scroll-to="'body'">
            <span class="top"></span>
            <span class="text">Вверх</span>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  computed: {
    getDesc() {
      return this.$i18n.messages[this.$i18n.locale].footer.footer_text;
    }
  },
  data(){
    return {
      locale: this.$route.params.locale
    }
  },
  watch: {
    $route(to) {
      this.locale = to.params.locale;
    }
  }
};
</script>

<style>
footer {
  position: relative;
  overflow: hidden;
}
.footer-logo {
  width: 80px;
}
footer .top_footer {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
}
footer .top_footer:after {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(8, 18, 37, 1);
  opacity: 0.9;
  content: "";
}
footer .top_footer_img {
  background-image: url("../assets/images/10.jpg");
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
}
footer .footer_widget {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  z-index: 2;
  padding: 83px 0 49px;
  box-sizing: border-box;
}
footer .footer_widget .inner {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
}
footer .footer_widget .inner:after {
  height: 6px;
  background-color: rgba(255, 255, 255, 0.05);
  right: 100%;
  left: -3000px;
}
footer .footer_widget .inner:before {
  height: 6px;
  background-color: rgba(255, 255, 255, 0.05);
  left: 0;
  right: 6px;
}
footer .footer_widget .inner:after,
footer .footer_widget .inner:before {
  margin-right: 0;
  position: absolute;
  top: 100%;
  margin-top: 43px;
  content: "";
}
footer ul.widget_area {
  list-style-type: none;
  margin: 0 0 0 -80px;
}
footer ul.widget_area > li {
  width: 50%;
  float: left;
  padding-left: 80px;
  margin-bottom: 40px;
  box-sizing: border-box;
}
footer .textwidget {
  padding: 0 0 0 15px;
  font-size: 12px;
}
footer .widget_block > .row {
  flex-wrap: unset;
}
footer .textwidget p,
footer .widget_block a,
footer .widget_block li,
footer .widget_businesshours p,
footer .widget_nav_menu ul li a,
footer table th {
  color: #ccc;
  font-weight: 300;
}
footer .widget_block img,
footer .widget_block p {
  margin: 10px 0;
}
footer .textwidget p {
  /*margin: 0;*/
  padding: 0;
  line-height: 1.7;
  letter-spacing: 0;
  font-size: 15px;
  font-weight: 400;
}
footer .textwidget p span {
  font-weight: bold;
}
footer .wid-title span,
footer .widget_block a:hover,
footer .widget_nav_menu ul li a:hover {
  color: #eee;
}
footer .wid-title span {
  font-weight: 300;
  display: block;
  font-size: 20px;
  color: #eee;
  margin-bottom: 24px;
  position: relative;
  line-height: 1.5;
  letter-spacing: 0;
}
footer .wid-title span:after {
  position: absolute;
  width: 50px;
  height: 1px;
  top: 100%;
  left: 0;
  margin-top: 3px;
  background-color: #d24e1a;
  content: "";
}
footer .widget_businesshours .fn_days ul,
footer .widget_nav_menu ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
footer .widget_businesshours .fn_days li {
  color: #ccc;
  font-weight: 300 !important;
  float: left;
  clear: both;
  width: 100%;
  margin: 0;
  padding: 3px 0;
  position: relative;
  border-bottom: 1px dashed rgba(204, 204, 204, 0.15);
}
footer .widget_businesshours .fn_days span {
  line-height: 1.7;
  float: left;
  font-size: 14px;
  color: #ccc;
  letter-spacing: 0;
}
footer .widget_businesshours .fn_days .hours {
  color: #d24e1a;
  float: right;
  font-weight: 400;
  margin-left: 20px;
}
footer .widget_nav_menu ul li {
  width: 50%;
  float: left;
  margin: 0;
  padding: 0 10px 0 0;
  box-sizing: border-box;
}
footer .widget_nav_menu ul li a {
  display: block;
  font-size: 14px;
  text-decoration: none;
  letter-spacing: 0;
  line-height: 2;
}
footer .footer_bottom {
  background-color: #081225;
  position: relative;
  width: 100%;
  float: left;
  clear: both;
}
footer .footer_bottom_in {
  width: 100%;
  float: left;
  clear: both;
  position: relative;
  background-color: #081225;
  padding: 61px 0 63px;
}
footer .footer_copyright p {
  margin: 0;
  padding: 0;
  color: #999;
}
footer a.scrolled {
  position: absolute;
  width: 51px;
  height: 51px;
  top: 50%;
  margin-top: -25px;
  right: 0;
  z-index: 25;
  overflow: hidden;
  display: block;
  text-align: center;
  cursor: pointer;
  transition: all 0.5s ease;
}
footer a.scrolled .top {
  display: block;
  width: 29px;
  height: 29px;
  background-color: #316397;
  position: absolute;
  left: 11px;
  top: 0;
  border-radius: 2px;
}
footer a.scrolled .top:after {
  content: "";
  width: 0;
  position: absolute;
  display: block;
  border: 5px solid transparent;
  border-bottom-color: #fff;
  left: 10px;
  bottom: 12px;
}
footer a.scrolled .text {
  position: absolute;
  left: 0;
  right: 0;
  top: 35px;
  text-transform: uppercase;
  font-size: 10px;
  line-height: 1;
  color: #999;
  letter-spacing: 0;
  font-weight: 700;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: all 0.3s ease;
}
footer a.scrolled:hover .text {
  color: #fff;
}
</style>
